if (!customElements.get('passcode-gate')) {
  customElements.define(
    'passcode-gate',
    class PasscodeGate extends HTMLElement {
      connectedCallback() {
        this.prompt = this.querySelector('.passcode-gate__prompt');
        this.content = this.querySelector('.passcode-gate__content');
        this.input = this.querySelector('.passcode-gate__input');
        this.submitButton = this.querySelector('.passcode-gate__submit');
        this.error = this.querySelector('.passcode-gate__error');
        this.storageKey = 'passcode-gate-' + this.dataset.productId;

        let stored = null;
        try {
          stored = sessionStorage.getItem(this.storageKey);
        } catch (e) {
          /* storage unavailable */
        }
        if (stored === this.dataset.passcodeHash) {
          this.unlock();
          return;
        }

        this.submitButton.addEventListener('click', () => this.check());
        this.input.addEventListener('keydown', (event) => {
          if (event.key === 'Enter') {
            event.preventDefault();
            this.check();
          }
        });
        this.input.addEventListener('input', () => {
          this.error.hidden = true;
        });
      }

      async check() {
        const value = this.input.value.trim().toLowerCase();
        if (!value) return;

        const hash = await this.sha256(value + ':' + this.dataset.productId);
        if (hash === this.dataset.passcodeHash) {
          try {
            sessionStorage.setItem(this.storageKey, hash);
          } catch (e) {
            /* storage unavailable */
          }
          this.unlock();
        } else {
          this.error.hidden = false;
          this.input.select();
        }
      }

      unlock() {
        this.prompt.hidden = true;
        this.content.hidden = false;
      }

      async sha256(text) {
        const data = new TextEncoder().encode(text);
        const digest = await crypto.subtle.digest('SHA-256', data);
        return Array.from(new Uint8Array(digest))
          .map((byte) => byte.toString(16).padStart(2, '0'))
          .join('');
      }
    }
  );
}
